import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { useState } from "react";
import { aboutRepo } from "@/lib/repositories";

const PAGE_SIZE = 10;

export function useAboutList() {
  const [page, setPage] = useState(1);

  const query = useQuery({
    queryKey: ["abouts", { page }],
    queryFn: () =>
      aboutRepo.fetchList({
        limit: PAGE_SIZE,
        offset: (page - 1) * PAGE_SIZE,
      }),
    placeholderData: keepPreviousData,
  });

  const abouts = query.data?.results ?? [];
  const pageCount = query.data ? Math.ceil(query.data.count / PAGE_SIZE) : 0;

  return {
    abouts,
    pageCount,
    page,
    setPage,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
  };
}
